/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Alinhamento',
  'company-hub.links-menu-extension.all.borders.label-text': 'Todos os lados',
  'company-hub.links-menu-extension.background.color': 'Cor do plano de fundo',
  'company-hub.links-menu-extension.background.title': 'Plano de fundo',
  'company-hub.links-menu-extension.border.color': 'Cor da borda',
  'company-hub.links-menu-extension.border.position': 'Posição da borda',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Borda inferior',
  'company-hub.links-menu-extension.center.option': 'Centralizar',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Adicione links importantes',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Link',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Agrupe links relacionados',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Você atingiu o número máximo de níveis aninhados.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menu',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Cancelar',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Excluir',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Essa ação vai excluir esse item, bem como todos os itens aninhados.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Excluir item',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Adicionar subitem',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Excluir item',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Editar propriedades',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Mover para baixo',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Mover para cima',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Abrir o link',
  'company-hub.links-menu-extension.config-panel.items.label': 'Itens',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'Você atingiu o número máximo de itens que podem ser adicionados a um menu de links.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Novo item',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Adicione e organize links com submenus. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Saiba mais sobre o menu de links',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Adicione e organize links com submenus.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Cancelar',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Confirmar',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Preencha este campo.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Exibir texto',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Nome do item',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Confirmar',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Mais',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Estilos',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'Você atingiu o número máximo de itens que podem ser adicionados a um menu de links.',
  'company-hub.links-menu-extension.config-panel.title': 'Menu de links',
  'company-hub.links-menu-extension.fixed.option': 'Fixado na parte superior',
  'company-hub.links-menu-extension.left.option': 'Esquerda',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Mais',
  'company-hub.links-menu-extension.manifest.extension-description':
    'Adicione vários links e submenus ao Hub da empresa',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Menu de links',
  'company-hub.links-menu-extension.manifest.extension-title': 'Menu de links [novo]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'Sobre nós',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Equipe 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Vantagens',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Equipes',
  'company-hub.links-menu-extension.no.border.label-text': 'Nenhuma',
  'company-hub.links-menu-extension.right.option': 'Direita',
  'company-hub.links-menu-extension.section.collapse.label': 'Recolher seção',
  'company-hub.links-menu-extension.section.expand.label': 'Expandir seção',
  'company-hub.links-menu-extension.selected.state.color': 'Cor do estado selecionada',
  'company-hub.links-menu-extension.text.color': 'Cor do texto',
  'company-hub.links-menu-extension.text.title': 'Texto',
};
